module.exports = __webpack_public_path__ + "img/horizontal-logo.8760f5a9.svg";